import { bool, number, object, string } from "yup";
import { PaymentFrequency } from "../../common/interfaces/enums/PaymentFrequency";
import PaymentPeriod from "../../common/interfaces/enums/PaymentPeriod";
import ProductType from "../../common/interfaces/enums/ProductType";
import { IQuoteSettings } from "../interfaces/form/IQuoteSettings";
import { IMortgageQuoteClient } from "../interfaces/form/mortgage/IMortgageQuoteClient";
import { calculateMaxMortgageMonthlyRepayments } from "../../common/shared/productHelpers";
import { isSelected } from "./ValidationHelpers";

const client = object<IMortgageQuoteClient>({
    isSelected: bool().notRequired().default(false),
    monthlyCover: isSelected(
        number(),
        number()
            .transform((v) => (v === "" || Number.isNaN(v) ? 0 : v))
            .positive("Please provide a monthly cover amount")
            .required("Please provider a monthly cover amount")
            .test(
                "monthly-cover-amount-max-text",
                "Monthly cover cannot be more that 110% your monthly repayments",
                function (val) {
                    const context = this.options?.context as IQuoteSettings;
                    if (!context || !context[ProductType.Mortgage]) return true; // If we don't have context, don't evaluate

                    const mortgage = context[ProductType.Mortgage];

                    return (
                        val <=
                        calculateMaxMortgageMonthlyRepayments(
                            mortgage.repaymentAmount,
                            mortgage.repaymentFrequency
                        )
                    );
                }
            )
    ),
    paymentPeriod: isSelected(
        string<PaymentPeriod>(),
        string<PaymentPeriod>().required("Please select a payment period")
    ),
    waitPeriodWeeks: isSelected(
        number(),
        number().required("Please select a wait period")
    )
});

const root = object<IQuoteSettings[ProductType.Mortgage]>().shape({
    mortgageAmount: number()
        .positive("Please enter a mortgage amount")
        .required("Please enter a mortgage amount"),
    repaymentAmount: number()
        .positive("Please enter a repayment amount")
        .required("Please enter a repayment amount"),
    repaymentFrequency: string<PaymentFrequency>()
        .oneOf(
            Object.values(PaymentFrequency).filter(
                (pf) => pf !== PaymentFrequency.Unknown
            ),
            "Please select a repayment frequency"
        )
        .required("Please select a repayment frequency")
});

export default { client, root };
